import { getGlobalSettings, getNavigation, getSeoSettings } from '~/services/custom-endpoints'

// get all singleton models at once
// (seo/global/navigation settings are fetched through their own cached server endpoints)
export const fetchSettings = async () => {
  const [
    { data: seoSettings, error: seoError },
    { data: globalSettings, error: globalError },
    { data: navigationSettings, error: navigationError }
  ] = await Promise.all([
    getSeoSettings(),
    getGlobalSettings(),
    getNavigation()
  ])

  if (seoError.value) {
    throw new Error('Empty SEO settings data returned.')
  }

  if (globalError.value) {
    throw new Error('Empty Global settings data returned.')
  }

  if (navigationError.value) {
    throw new Error('Empty navigation settings data returned.')
  }

  // if (projectError.value) {
  //   throw new Error('Empty project settings data returned.')
  // }

  return {
    seo: seoSettings.value,
    global: globalSettings.value,
    navigation: navigationSettings.value
    // project: projectSettings.value,
  }
}
